import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import clsx from 'clsx';
import {
  AppBar,
  Box,
  Breadcrumbs,
  Hidden,
  IconButton,
  Toolbar,
  Typography,
  Grid,
  Divider,
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../hooks/auth';
import { useStyles } from './styles';

import mineraiLogo from '../../../assets/logo_minerai.png';
import avatarImg from '../../../assets/avatarimage.png';

interface ITopBarProps {
  className?: string;
  handleDrawer: any;
}

const TopBar: React.FC<ITopBarProps> = ({
  className,
  handleDrawer,
  ...rest
}) => {
  const classes = useStyles();
  const { user } = useAuth();
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const [breadcrumbText, setBreadcrumbText] = useState('');

  useEffect(() => {
    const splitPath = location.pathname.split('/');
    const routeName = splitPath[splitPath.length - 1];
    const path = `routes:${routeName}` as any;
    setBreadcrumbText(t(path));
  }, [location, t]);

  return (
    <AppBar
      position="fixed"
      className={clsx(classes.appBar, className)}
      elevation={0}
      {...rest}
    >
      <Toolbar disableGutters className={classes.header}>
        <IconButton
          size="small"
          color="primary"
          className={classes.menuIcon}
          onClick={handleDrawer}
        >
          <MenuIcon style={{ fontSize: 32 }} />
        </IconButton>
        {/* md */}
        <Hidden xsDown>
          <button
            type="button"
            onClick={() => history.push('/dashboard')}
            className={classes.logoButton}
          >
            <img alt="minerAI" src={mineraiLogo} style={{ height: 44 }} />
          </button>
        </Hidden>
        <Hidden smUp>
          <div className={classes.imageContainer}>
            <button
              type="button"
              onClick={() => history.push('/dashboard')}
              className={classes.logoButtonMobile}
            >
              <img alt="minerAI" src={mineraiLogo} style={{ height: 44 }} />
            </button>
          </div>
        </Hidden>
        <Box flexGrow={1} />
        <Hidden xsDown>
          <Divider flexItem orientation="vertical" />
          <Grid
            item
            xs={6}
            sm={4}
            md={4}
            lg={3}
            xl={2}
            className={classes.breadcrumbContainer}
          >
            <Breadcrumbs aria-label="breadcrumb">
              <Typography
                color="textPrimary"
                variant="subtitle1"
                className={classes.breadcrumbText}
              >
                {breadcrumbText}
              </Typography>
            </Breadcrumbs>
          </Grid>
        </Hidden>
        <IconButton
          className={classes.avatarButton}
          onClick={() => history.push('/dashboard/configuracoes/perfil')}
        >
          <img
            alt="avatar"
            src={user.avatar_url ? user.avatar_url : avatarImg}
            className={classes.avatarImage}
          />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;
